function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "relative", "onClick", "closeIcon", "background"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from 'prop-types';
import cls from "../../lib/cls";
import classes from "../../../design-system/scss/components/backdrop.module.scss";
import Box from "../Box";
import { CloseBold } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Backdrop = function Backdrop(_ref) {
  var children = _ref.children,
    relative = _ref.relative,
    onClick = _ref.onClick,
    closeIcon = _ref.closeIcon,
    background = _ref.background,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    onClick: onClick,
    "aria-label": "Click to close",
    role: "presentation",
    clickable: true,
    className: cls({
      backdrop: true,
      'backdrop--relative': relative,
      'backdrop--background': background
    }, classes)
  }, props), {}, {
    children: [closeIcon && /*#__PURE__*/_jsx(Box, {
      className: classes['backdrop__close'],
      children: /*#__PURE__*/_jsx(CloseBold, {})
    }), children]
  }));
};
Backdrop.defaultProps = {
  children: null,
  relative: false,
  onClick: function onClick() {},
  closeIcon: false,
  background: true
};
Backdrop.propTypes = {
  children: PropTypes.node,
  relative: PropTypes.bool,
  onClick: PropTypes.func,
  closeIcon: PropTypes.bool,
  background: PropTypes.bool
};
export default Backdrop;